import captureSentryException from '../../../../tracking/sentry/captureSentryException';
import analytics from '../../index';

function pasteHandler() {
  try {
    const { activeElement } = document;
    const pastePayload = {
      active_element_id: activeElement?.id,
    };
    analytics.track('paste', pastePayload);
  } catch (error) {
    captureSentryException(error);
  }
}

export default pasteHandler;
